module.exports = __webpack_public_path__ + "assets/img/be71-mf.svg";